
<template>
<div class="print_bg" v-if="show">
    <div class="wrap">
      <div class="title">提示：打印机状态存在异常</div>
      <div slot="content" class="selfContent">
        <div class="itemView" v-if="$store.state.connetStatus.lodopStatus">
          <img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">打印机插件已安装</span>
        </div>
        <div class="itemView" v-else>
          <img src="../assets/images/pcerror.png" class="selftootipImg">打印插件未安装,
            <el-link type="primary" :href="downloadUrl32">点击下载32位</el-link>，
            <el-link type="primary" :href="downloadUrl64">点击下载64位</el-link>，安装成功后请刷新本页面或重启浏览器。
        </div>
        <div class="itemView" v-if="$store.state.connetStatus.WebSocketstatus">
          <img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">websocket通讯正常</span>
        </div>
        <div class="itemView" v-else>
          <img src="../assets/images/pcerror.png" class="selftootipImg">websocket通讯异常,请刷新浏览器
          <el-button type="text" icon="el-icon-refresh" class="ml_10" @click="loadPage">点击刷新</el-button>
        </div>
        <div class="itemView" v-if="$store.state.connetStatus.name">
          <img src="../assets/images/pcnorlmal.png" class="selftootipImg"><span class="colorgreen">默认打印机设置正常</span>
        </div>
        <div class="itemView" v-else>
          <img src="../assets/images/pcerror.png" class="selftootipImg">默认打印机设置异常
          <el-button type="text" icon="el-icon-s-tools" class="ml_10" @click="goSet">去设置</el-button>
        </div>
      </div>
      <div class="btnBox"><el-button type="primary" @click="show=false" style="margin-top:30px" size="small">我知道了</el-button></div>     
    </div>
  </div>
</template>
<script>
import util from '@/util/util';
export default {
  data() {
    return {
      show: true,
      contentData:{},
      type:'',
      downloadUrl32:'',
      downloadUrl64:'',
    };
  },
  created() {

  },
  mounted(){
     this.downloadUrl32 = util.getJsonValues(this.$store.state.commondict,'lodopurl32')||'http://www.lodop.net/demolist/CLodop_Setup_for_Win32NT.zip'
     this.downloadUrl64 = util.getJsonValues(this.$store.state.commondict,'lodopurl64')||'http://lodop.net/download/CLodop_Setup_for_Win64NT_4.158EN.zip'
  }, 
  methods: {
    loadPage(){
      this.show = false;
      window.location.reload();
    },
    goSet(){
      this.show = false;
      this.$store.commit('SET_ROUTE_FROM','/setTemplate')
      window.location.replace(window.location.origin + '/setTemplate')
    }
  },
};
</script>
 
<style lang="stylus" scoped>
.print_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
  font-size 14px;
}
.wrap {
  background-color: #ffffff;
  width: 520px;
  height: 260px;
  z-index: 99;
  line-height: 30px;
  text-align: left;
  z-index: 99;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -260px;
  margin-top: -130px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  animation-name: wrapscale;
  animation-duration: 300ms;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-delay: 0s;
  .title{
     padding-top: 20px;
     padding-left: 50px;
     font-size: 15px;
     font-weight: bold;
  }
  .selfContent{
    padding-top: 4px;
    padding-left: 50px;
    font-size: 14px;
    padding-right: 50px;
    .itemView{
      .ml_10{
        margin-left: 10px
      }
      img{
        width: 20px;
        height: 20px;
        vertical-align: text-bottom;
        margin-right: 20px
      }
      .colorgreen{
        color: #19DA92;
      }
    }
  }
  @keyframes wrapscale {
    0% {
      top: 100%;
    }
    100% {
      top: 50%;
    }
  }
}
.btnBox{
  text-align: center;
}

</style>